import { Navigate } from 'react-router-dom';
import { useUsersStore } from '@/stores/users';
import { ERouterNames, EUserRoles } from '@/types';
import { homepageByRole, SESSION_STORAGE_KEYS } from '@/utils/constants';
import { getLinkToLogin } from '@/utils/getLinkToLogin';
import { isSafeRedirect } from '@/utils/safeRedirect';

export const AuthCheckLayout = () => {
  const { isSuperAdmin, role, orgAdminOrganizationIds } = useUsersStore(
    (state) => ({
      isSuperAdmin: state.checkIsSuperAdmin(),
      role: state.role,
      orgAdminOrganizationIds: state.getOrgAdminOrganizationIds(),
    }),
  );
  const userRole = isSuperAdmin ? EUserRoles.ADMIN : role;
  const homepage = userRole
    ? homepageByRole[userRole]
    : orgAdminOrganizationIds.length
      ? ERouterNames.USERS_TABLE
      : getLinkToLogin();

  const returnPath = sessionStorage.getItem(SESSION_STORAGE_KEYS.REDIRECT_PATH);

  if (returnPath && (userRole || orgAdminOrganizationIds.length)) {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.REDIRECT_PATH);
    if (isSafeRedirect(returnPath)) {
      return <Navigate to={returnPath} replace />;
    }
  }

  return <Navigate to={homepage} replace />;
};
